import React from "react"
import { Grid } from "@bw/bits"
import PropTypes from "prop-types"
import { breakpoints } from "../../../theme"
import styled from "styled-components"

const Column = styled.div`
  > :first-child {
    margin-top: 0;
  }
`

const Columns = ({ count, contents, children }) => {
  return (
    <Grid columns={count}>
      {children ||
        contents.map((item, i) => (
          <Column key={i}>
            {item.title && <h3>{item.title}</h3>}
            {item.content}
          </Column>
        ))}
    </Grid>
  )
}

Columns.propTypes = {
  count: PropTypes.number,
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
    })
  ),
}

Columns.defaultProps = {
  count: 2,
}

export { Columns }
